
import Vue from "vue";
import UserProvisioning from '@/mixins/userProvisioning';
export default Vue.extend({
  name: "PlanningChecklistComponent",
  mixins: [UserProvisioning],

  props: ["projectId", "departmentId", "departments","operationUnitId","readOnlyView"],
  data() {
    return {
      fields: [
        { key: "sn", label: "S/N" },
        { key: "name", label: "Name" },
        { key: "value", label: "Value" },
        { key: "criticality", label: "Criticality" },
        { key: "files", label: "Attachments" },
        {key:"actions",label:"Action"}
      ],

      valueTypes: [
        { text: "Boolean (Yes or No)", value: "BOOLEAN" },
        { text: "Range", value: "RANGE" },
        { text: "Percentage", value: "PERCENTAGE" },
        {
          text: "Status (Not Started, In Progress, Completed) ",
          value: "STATUS",
        },
      ],
      planningItem: {
        name: "",
        valueType: null,
        minValue: 0,
        maxValue: 0,
        departmentId:"",
        operationUnitId:"",
        criticality:false
      },
      selectedDepartment: null,
      isCreated: true,
      editingPreProcess: {id:""},
    };
  },
  computed: {
    project(): any {
      return this.$store.getters["projectModule/getProjectById"](
        this.projectId
      );
    },
    preProcesses(): any {
      if (this.project !== undefined) {
        if (this.departmentId === "All") {
          return this.project.preProcesses;
        } else {
          return this.project.preProcesses.filter(
            (x: any) => (x.departmentId == this.departmentId) && (x.operationUnitId==this.operationUnitId)
          );
        }
      } else {
        return [];
      }
    },
    showDepartmentForm(): boolean {
      if (this.departmentId === "All") {
        return true;
      }
      return false;
    }
  },
  methods: {
    reInitPalnningItem() {
      this.planningItem = {
        name: "",
        valueType: null,
        minValue: 0,
        maxValue: 0,
        departmentId:this.departmentId,
        operationUnitId:this.operationUnitId,
        criticality:false,
      };
    },
    gotoEdit(data: any) {
      this.isCreated = false;
      this.editingPreProcess = data;
      this.planningItem = {
          name:data.name,
          valueType:data.valueType,
          minValue:data.minValue,
          maxValue:data.maxValue,
          departmentId:data.departmentId,
          operationUnitId:data.operationUnitId,
          criticality:data.criticality,
      }
      this.$bvModal.show("planningModal");
    },
    deletePreProcess(preProcess: any) {
      this.$store.commit('projectModule/deletePreProcessFromProject', {
        sequenceId: this.project.sequenceId,
        id: this.project.id,
        preProcessId: preProcess.id
      });
      this.$bvToast.toast('PreProcess deleted successfully!', {
        title: 'Success',
        variant: 'success',
        solid: true
      });
    },
    showPlanningModal() {
      this.reInitPalnningItem();
      this.isCreated = true;
      this.$bvModal.show("planningModal");
    },
    doCreatePlanningItem() {
      let preProcess = {
        name: this.planningItem.name,
        valueType: this.planningItem.valueType,
        maxValue: this.planningItem.maxValue,
        minValue: this.planningItem.minValue,
        departmentId: String(this.planningItem.departmentId),
        operationUnitId: this.planningItem.operationUnitId,
        criticality: this.planningItem.criticality,
      };
      
      this.$store.commit("projectModule/addOrUpdatePlanningItemToProject", {
        sequenceId: this.project.sequenceId,
        id: this.project.id,
        preProcess,
      });
      this.$bvModal.hide("planningModal");
      this.reInitPalnningItem();
    },
    onPlanningItemValueChanged() {
      this.$store.commit("projectModule/registerProjectChange", {
        sequenceId: this.project.sequenceId,
        projectId: this.project.id,
      });
    },
    updateCreatePlanningItem(){
        const index = this.project.preProcesses.findIndex((x:any) => x.id === this.editingPreProcess.id);
        if(index>-1){
            this.project.preProcesses[index].name = this.planningItem.name;
            this.project.preProcesses[index].maxValue = this.planningItem.maxValue;
            this.project.preProcesses[index].minValue = this.planningItem.minValue;
            this.project.preProcesses[index].valueType = this.planningItem.valueType;
            this.project.preProcesses[index].departmentId = this.planningItem.departmentId;
            this.project.preProcesses[index].operationUnitId = this.planningItem.operationUnitId;
            this.project.preProcesses[index].criticality = this.planningItem.criticality;
        }
        this.onPlanningItemValueChanged()
        this.$bvModal.hide("planningModal");
        this.reInitPalnningItem()
    },
  },
  mounted() {
    if(this.departmentId!="All")this.planningItem.departmentId = String(this.departmentId)
    this.planningItem.operationUnitId = this.operationUnitId
  },
});
